module.exports = __webpack_public_path__ + "exo-latin-300.038973967594a7dab606.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-300.woff2
// module id = ../../../../typeface-exo/files/exo-latin-300.woff2
// module chunks = styles